'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_time_format_DecimalStyle(zeroDigit, positiveSign, negativeSign, decimalSeparator) {
  this.gU = 0;
  this.iN = 0;
  this.jU = 0;
  this.iM = 0;
  this.gU = zeroDigit;
  this.iN = positiveSign;
  this.jU = negativeSign;
  this.iM = decimalSeparator;
}
export { $c_Ljava_time_format_DecimalStyle as $c_Ljava_time_format_DecimalStyle };
$p = $c_Ljava_time_format_DecimalStyle.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_DecimalStyle;
/** @constructor */
function $h_Ljava_time_format_DecimalStyle() {
}
export { $h_Ljava_time_format_DecimalStyle as $h_Ljava_time_format_DecimalStyle };
$h_Ljava_time_format_DecimalStyle.prototype = $p;
$p.Os = (function(ch) {
  var value = ((ch - this.gU) | 0);
  return (((value >>> 0) <= 9) ? value : (-1));
});
$p.Or = (function(numericText) {
  if ((this.gU === 48)) {
    return numericText;
  }
  var diff = ((this.gU - 48) | 0);
  var array = $j_java$002elang$002e$002dObject.$f_T__toCharArray__AC(numericText);
  var i = 0;
  while ((i < array.a.length)) {
    array.a[i] = (65535 & ((array.a[i] + diff) | 0));
    i = ((1 + i) | 0);
  }
  return $j_java$002elang$002e$002dObject.$m_jl_String$().PG(array, 0, array.a.length);
});
$p.f = (function(obj) {
  return ((obj instanceof $c_Ljava_time_format_DecimalStyle) && ((this === obj) || ((((this.gU === obj.gU) && (this.iN === obj.iN)) && (this.jU === obj.jU)) && (this.iM === obj.iM))));
});
$p.m = (function() {
  return ((((((this.gU + this.iN) | 0) + this.jU) | 0) + this.iM) | 0);
});
$p.b = (function() {
  return ((((("DecimalStyle[" + $j_java$002elang$002e$002dObject.$cToS(this.gU)) + $j_java$002elang$002e$002dObject.$cToS(this.iN)) + $j_java$002elang$002e$002dObject.$cToS(this.jU)) + $j_java$002elang$002e$002dObject.$cToS(this.iM)) + "]");
});
function $isArrayOf_Ljava_time_format_DecimalStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dI)));
}
export { $isArrayOf_Ljava_time_format_DecimalStyle as $isArrayOf_Ljava_time_format_DecimalStyle };
var $d_Ljava_time_format_DecimalStyle = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_DecimalStyle, "java.time.format.DecimalStyle", ({
  dI: 1
}));
export { $d_Ljava_time_format_DecimalStyle as $d_Ljava_time_format_DecimalStyle };
